import { Component, Input, OnChanges, Inject } from '@angular/core';
import GuestConfirmationStatusTagView from './guest-confirmation-status-tag.component.html';
import { TranslateService, _ } from '@ngx-translate/core';
import { Subscription, takeUntil } from 'rxjs';
import { BaseDestroyableComponent } from '../../../../shared/base/base-destroyable.component';


@Component({
  selector: 'guest-confirmation-status-tag',
  template: GuestConfirmationStatusTagView,
  styles: [`.guest-confirmation-status-tag {
     padding: 2px 7px;
     margin-right: 5px;
    }`]
})
export class GuestConfirmationStatusTagComponent extends BaseDestroyableComponent implements OnChanges {
  @Input() status: string;
  @Input() answerDate?: Date | null;
  tooltipText: string = '';
  private tooltipSub?: Subscription;

  constructor(@Inject(TranslateService) private translate: TranslateService) { super(); }

  // ngOnChanges y no ngOnInit: el estado cambia sin recrear el componente (y el virtual scroll recicla filas)
  ngOnChanges() {
    // stream() en vez de instant(): instant() devuelve la clave si el diccionario todavia no ha
    // llegado, y el tooltip se quedaba con "events.guests.pending" hasta recargar. stream()
    // reemite cuando el diccionario carga o cambia el idioma.
    this.tooltipSub?.unsubscribe();
    this.tooltipSub = this.translate.stream(_('events.guests.' + this.status))
      .pipe(takeUntil(this.destroy$))
      .subscribe(texto => {
        this.tooltipText = this.answerDate
          ? texto + ': ' + new Date(this.answerDate).toLocaleString('es')
          : texto;
      });
  }

  getTagStyle(): object {
    const style: Record<string, string> = { 'margin-right': '5px' };
    if (this.status === 'pending_approval') {
      style['background-color'] = '#c4a84d';
    } else if (this.status === 'manage_delegate') {
      // Mismo gris que .label-default-custom de la legacy
      style['background-color'] = '#c2c2c2';
    }
    return style;
  }
}
